import React, { useRef, useState } from 'react';
import './style.scss';
import styles from "./styles.module.scss";
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import CustomDatePickerV2 from 'views/pages/manage/common/commonComponents/CustomDatePicker-V2';
import moment from 'moment';
import { labelSyle } from 'views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/constant';
import { headerColumnStyle, inputAmountStyle, inputStyle, hardcodeDropdown } from './constant';
import { Label } from 'reactstrap';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import CustomUpload from '../sapPurchaseOrder/CustomUpload';
import CustomDownload from '../sapPurchaseOrder/CustomDownload';

export const steps = [
    "General",
    "Vendor",
    "DMS Attachment",
];

export const downloadFileHandler = (fileData, setIsDownloaded) => {
    setIsDownloaded(true);
    const base64Data = fileData;
    if (!base64Data) {
        alert("No attachment available");
        return;
    }

    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = 'attachment'; // no extension — unless backend provides it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Cleanup
    setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
};

const Header = ({ headerRows = {}, headerFormHandler, filterFormHandler, fileData, setFileData, grnType, setIsDownloaded }) => {
    const [currentStep, setCurrentStep] = useState(0);
    const handleHeaderTab = (index) => {
        setCurrentStep(index)
    }

    return (
        <>
            <div className='stepper_grn mt-2'>
                {steps.map((item, index) => (
                    <div
                        key={index}
                        className={`step ${index === currentStep ? "active" : ""}`}
                        onClick={() => handleHeaderTab(index)}
                    >
                        <div className="step-text flex ">
                            {item}</div>
                    </div>
                ))}
            </div>
            <div className='d-flex mt-2'>
                {currentStep == 0 && <><div style={headerColumnStyle}>
                    <CustomDatePickerV2
                        placeHolder="From"
                        value={headerRows?.docDate ?? ''}
                        width={"18px"}
                        handler={(index, date, keyName) => {
                            headerFormHandler("docDate", date);
                        }}
                        label="Document Date"
                    />
                </div>
                    <div style={headerColumnStyle}>
                        <CustomDatePickerV2
                            placeHolder=""
                            value={headerRows?.postingDate}
                            width={"18px"}
                            // handler={(index, date, keyName) => {
                            //     headerFormHandler("postingDate", date);
                            // }}
                            label="Posting Date*"
                            disabled={true}
                        />
                    </div>
                    <div style={headerColumnStyle}>
                        <AInput
                            type="text"
                            value={headerRows?.deliveryNote}
                            handler={(value) => {
                                headerFormHandler("deliveryNote", value);
                            }}
                            placeholder="Enter"
                            label='Delivery Note'
                            labelSyle={labelSyle}
                            style={inputAmountStyle}
                        />
                    </div>

                    <div style={headerColumnStyle}>
                        <AInput
                            type="text"
                            value={headerRows?.poNumber}
                            handler={(value) => {
                                headerFormHandler("poNumber", value);
                            }}
                            placeholder="Enter"
                            label='PO Number'
                            labelSyle={labelSyle}
                            style={inputAmountStyle}
                            disabled={true}
                        />
                    </div>

                    <div style={headerColumnStyle}>
                        <AInput
                            type="text"
                            value={headerRows?.billOfLading}
                            handler={(value) => {
                                headerFormHandler("billOfLading", value);
                            }}
                            placeholder="Enter"
                            label='Bill Of Lading'
                            labelSyle={labelSyle}
                            style={inputAmountStyle}
                            disabled={false}
                        />
                    </div>
                    <div style={headerColumnStyle}>
                        <AInput
                            type="text"
                            value={headerRows?.headerText}
                            handler={(value) => {
                                headerFormHandler("headerText", value);
                            }}
                            placeholder="Enter"
                            label="Header Text"
                            labelSyle={labelSyle}
                            style={inputAmountStyle}
                            disabled={false}
                        />
                    </div>

                    <div style={{ ...headerColumnStyle, padding: "0px 0px" }}>
                        <AAutoComplete
                            label="Movement Type*"
                            placeholder="Select"
                            currentValue={
                                headerRows?.mvtType || hardcodeDropdown?.mvtType.find(item => item.value === "101")
                            }
                            handleChange={(value) => { headerFormHandler("mvtType", value) }}
                            items={grnType?.value === "101"
                                ? hardcodeDropdown?.mvtType.filter(item => item.value === "101") :
                                grnType?.value === "102" ? hardcodeDropdown?.mvtType.filter(item => item.value !== "101")
                                    : hardcodeDropdown?.mvtType}
                            isMulti={false}
                            isShowCount={false}
                            style={{ control: inputStyle }}
                            isInputChange={true}
                            isDisabled={false}
                        />
                    </div>
                </>
                }
                {currentStep == 1 &&
                    <>
                        <div style={headerColumnStyle}>
                            <AInput
                                type="text"
                                value={headerRows?.vendor}
                                handler={(value) => {
                                    headerFormHandler("vendor", value);
                                }}
                                placeholder="Enter"
                                label='Vendor'
                                labelSyle={labelSyle}
                                style={inputAmountStyle}
                                disabled={true}
                            />
                        </div>
                        <div style={headerColumnStyle}>
                            <AInput
                                type="text"
                                value={headerRows?.receivingVendor}
                                handler={(value) => {
                                    headerFormHandler("receivingVendor", value);
                                }}
                                placeholder="Enter"
                                label='Receiving Vendor'
                                labelSyle={labelSyle}
                                style={inputAmountStyle}
                                disabled={true}
                            />
                        </div>
                    </>
                }

                {currentStep == 2 && <div style={{ ...headerColumnStyle, width: "30%" }}>
                    {/* <Label style={{ ...labelSyle, marginTop: '7px' }}>
                        DMS Attachment
                    </Label> */}
                    {grnType?.value == '101' ? (
                        <div className={`${styles["upload-btn-style"]}`}>
                            <CustomUpload
                                fileData={fileData}
                                setFileData={setFileData}
                                id={"sap-file"} />
                        </div>) : (
                        <CustomDownload
                            fileData={fileData}
                            onClick={() => downloadFileHandler(fileData, setIsDownloaded)}
                        />
                    )
                    }
                </div>
                }
            </div>
        </>
    )
}
export default Header